import { useCallback, useRef } from 'react';
import { useSSEConnection } from '../../../../hooks/useSSEConnection';
import { useOTCSyncProgress } from '../../../../store/otcProgressStore';
import { SyncProgressEvent } from './types';

export const useOTCSyncSSE = () => {
  const { updateFromEvent, complete: completeSync } = useOTCSyncProgress();
  const disconnectRef = useRef<(() => void) | null>(null);

  const handleMessage = useCallback(
    (data: SyncProgressEvent) => {
      updateFromEvent(data);

      if (data.type === 'complete') {
        completeSync();
        disconnectRef.current?.();
      }
    },
    [updateFromEvent, completeSync]
  );

  const { connect, disconnect } = useSSEConnection<SyncProgressEvent>(
    '/otc/sync-progress',
    { onMessage: handleMessage }
  );

  // Store disconnect ref for use in handleMessage
  disconnectRef.current = disconnect;

  return { connect, disconnect };
};
